import { createReducer } from '@reduxjs/toolkit';
import { actions } from './actions';
const initialState = {
    data: {
        _path: '',
        expTitle: '',
        expLocation: [],
        expType: [],
        expLevel: '',
        expDuration: 0,
        expDistance: 0,
        expPrice: 0,
        expDateRanges: [],
        currencyCode: '',
        vehicleRental: '',
        expDescription: {
            html: '',
        },
        expEquipment: {
            html: '',
        },
        partnerRecommendation: {
            html: '',
        },
        itinerary: {
            html: '',
        },
        expIncluded: [
            {
                html: '',
            },
        ],
        expAssets: [],
        primaryImage: {
            src: '',
        },
        units: [],
        tags: [],
        relatedExperiences: [],
        partnerReference: {
            _path: '',
            partnerName: '',
            partnerLogo: {
                _path: '',
            },
        },
        edpPath: '',
    },
    relatedUnits: [],
    isLoaded: false,
};
function setExperienceDetailsData(state, { payload }) {
    return {
        ...state,
        data: payload,
    };
}
function setRelatedUnitsData(state, { payload }) {
    return {
        ...state,
        relatedUnits: payload,
    };
}
function setExperienceDetailsDataLoaded(state, { payload }) {
    return {
        ...state,
        isLoaded: payload,
    };
}
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(actions.setExperienceDetailsData, setExperienceDetailsData)
        .addCase(actions.setRelatedUnitsData, setRelatedUnitsData)
        .addCase(actions.setExperienceDetailsDataLoaded, setExperienceDetailsDataLoaded)
        .addCase(actions.setInitialExperienceDetailsData, () => initialState);
});
